import { PropsWithChildren } from 'react';

export const InputInstructions = (props: PropsWithChildren<NonNullable<unknown>>) => {
  const { children } = props;

  return <p className="text-neutral-neutral text-center">{children}</p>;
};
